// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".js?ver=" + {"vendors-node_modules_html2canvas_dist_html2canvas_js":"4aa988245bde0611bb43","vendors-node_modules_dompurify_dist_purify_es_mjs":"ac3f19abb16d463273cc","vendors-node_modules_canvg_lib_index_es_js":"702e996a87ec624968ef"}[chunkId] + "";
};